import load from 'load-script'
import once from 'lodash/once'
import { apiClient } from 'pobble-components/dist/api'
import { getPobbleEnv } from 'pobble-components/dist/utils'

const FacebookAppIds = {
  local: '2868708063353501',
  stg: '150791807644447',
  prod: '1448514002110119'
}

const initFacebookSDK = once(() => {
  return new Promise((resolve, reject) => {
    load('https://connect.facebook.net/en_US/sdk.js', err => {
      if (err)
        return reject(
          console.error('Oauth: Facebook SDK initialization error', err)
        )
      if (!window.FB)
        return reject(
          console.error('Oauth: Facebook seems to be blocked by a firewall')
        )
      resolve(
        window.FB.init({
          appId: FacebookAppIds[getPobbleEnv()],
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v3.3'
        })
      )
    })
  })
})

const apiFacebookLogin = (data, params) =>
  apiClient.post('v3/facebook_authentication', data, { params })

const apiFacebookConnect = (data, params) =>
  apiClient.post('/v3/facebook_authentication/connect_oauth_identity', data, {
    params
  })

const facebookConnect = () => {
  return new Promise((resolve, reject) => {
    window.FB.login(response => {
      if (!response.authResponse) {
        return reject('CANCEL')
      }
      apiFacebookConnect(
        { code: response.authResponse.accessToken },
        { include: 'account.oauth_identities,account.oauth_identity.provider' }
      )
        .then(resolve)
        .catch(reject)
    })
  })
}

const facebookLogin = () => {
  return new Promise((resolve, reject) => {
    window.FB.login(response => {
      if (!response.authResponse) {
        return reject('CANCEL')
      }
      return apiFacebookLogin(
        { code: response.authResponse.accessToken },
        { include: 'account.finish_signup_status' }
      )
        .then(resolve)
        .catch(reject)
    })
  })
}

export { initFacebookSDK, facebookLogin, facebookConnect }
